
import React, { useEffect, useState } from 'react';
import { json, Link, useNavigate } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import Button from '@mui/material/Button';
import Sidebar from './Sidebar'; // Import the new component
import '../Static/PHPStatic/Navigation.css'; // Import the CSS file

const customButtonStyle = {
  textTransform: 'capitalize',
  fontVariant: 'lowercase',
  borderColor: 'white',
  color: 'white'
};

const Navigation = ({ children }) => {
  const [sidebarr, setSidebarr] = useState(false);
  const [users, setUsers] = useState({});
  const navigate = useNavigate();
  const toggleSidebar = () => {
    setSidebarr(!sidebarr);
  };
  const userData = localStorage.getItem('user');

  useEffect(() => {
    const interval = setInterval(() => {
      const expiry = localStorage.getItem("expiry");

      if (expiry && Date.now() > expiry) {
        localStorage.clear();
        sessionStorage.clear();
        alert("Session expired, login again");
        navigate('/Login');
      }
    }, 60 * 1000); //check every 1 min
    return () => clearInterval(interval);
  }, [])
  
  useEffect(() => {
    if (userData === null) {
      navigate('/');
      window.location.reload();
    }

    if (userData) {
      const data = JSON.parse(userData);
      setUsers(data);
    }

  }, [userData]);
  const handleLogout = () => {
    sessionStorage.removeItem('user');
    localStorage.removeItem('user');

    navigate('/');
    window.location.reload();
  };

  return (
    <IconContext.Provider value={{ color: '#fff' }}>
      <div className={`content-wrapper ${sidebarr ? '' : 'no-sidebar'}`}>
        <div className="nav">
          <Link className="nav-icon" to="#">
            <FaIcons.FaBars onClick={toggleSidebar} />
          </Link>
          <h2 className="nav-title">Uniform Manufacture System : ({users?.userNm})</h2>
          {/* <div className="nav-btn">
            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle}>Honesty</Button>
            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle}>Ticket</Button>
            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle}>Reply</Button>
            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle}>Logout</Button>
          </div> */}
          <div className="nav-btn">
            {users?.role === "1" && <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle} onClick={() => navigate('/new-user-creating')}>Add Users</Button>}

            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle} onClick={handleLogout}>Logout</Button>
          </div>
        </div>
        <Sidebar sidebarr={sidebarr} />

        <div style={{ margin: '0.5%' }}>
          {children}
        </div>
      </div>
    </IconContext.Provider>
  );
};

export default Navigation;
